import { HTMLAttributeAnchorTarget, useCallback } from 'react'
import { isNativeMobile } from '@/authenticated/hooks/useIsMobile'
import { isSafari } from 'react-device-detect'

export const normalizeUrl = (url: string) => {
  return /^(http|https):\/\//i.test(url) ? url : `https://${url}`
}

export default function useExternalNavigation() {
  const externallyNavigate = useCallback(
    (url: string, target: HTMLAttributeAnchorTarget = '_blank') => {
      // Add https:// if the URL doesn't start with http:// or https://
      const normalizedUrl = normalizeUrl(url)

      if (isNativeMobile() || isSafari) {
        window.location.href = normalizedUrl
      } else {
        window.open(normalizedUrl, target)
      }
    },
    [],
  )

  return { externallyNavigate }
}
